<template>
  <div
    class="relative overflow-hidden"
    @touchstart="onTouchStart"
    @touchmove="onTouchMove"
    @touchend="onTouchEnd"
  >
    <!-- Action buttons container -->
    <div class="absolute right-0 top-0 h-full flex items-center">
      <!-- Clock button -->
      <div 
        class="h-full bg-blue-500 text-white flex items-center overflow-hidden transition-all duration-300 ease-out"
        :style="{ width: `${getButtonWidth(75)}px` }"
      >
        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 mx-auto" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      </div>
      <!-- Delete button -->
      <div 
        class="h-full bg-red-500 text-white flex items-center overflow-hidden transition-all duration-300 ease-out"
        :style="{ width: `${getButtonWidth(75)}px` }"
      >
        <span class="mx-auto">Delete</span>
      </div>
    </div>

    <!-- Main Content -->
    <div
      class="bg-white touch-pan-x"
      :class="{ 'transition-transform duration-500 ease-out': isAnimating }"
      :style="{ transform: `translateX(${offset}px)` }"
    >
      <div class="p-4 border-b">Swipe me left</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      startX: 0,
      currentX: 0,
      offset: 0,
      initialOffset: 0, // Track starting position for reverse swipe
      isDragging: false,
      isAnimating: false,
      maxOffset: -150
    }
  },
  methods: {
    getButtonWidth(maxWidth) {
      // Calculate progressive width based on swipe progress
      const progress = Math.abs(this.offset) / Math.abs(this.maxOffset)
      return Math.round(maxWidth * progress)
    },
    onTouchStart(e) {
      if (this.isAnimating) return
      this.startX = e.touches[0].clientX
      this.initialOffset = this.offset // Store current position
      this.isDragging = true
      this.isAnimating = false
    },
    onTouchMove(e) {
      if (!this.isDragging) return
      
      this.currentX = e.touches[0].clientX
      const diff = this.currentX - this.startX
      
      // Add diff to initial offset for smooth continuation
      const newOffset = this.initialOffset + diff
      this.offset = Math.max(this.maxOffset, Math.min(0, newOffset))
    },
    onTouchEnd() {
      if (!this.isDragging) return
      
      this.isDragging = false
      this.isAnimating = true
      
      // Calculate velocity of the last movement
      const velocity = this.currentX - this.startX
      
      // If swiped more than 1/3 of max or has significant closing velocity
      if (this.offset < this.maxOffset / 3 && velocity < 50) {
        this.offset = this.maxOffset // Fully open
      } else if (this.offset > -this.maxOffset / 3 || velocity > 50) {
        this.offset = 0 // Snap back
      } else {
        this.offset = this.maxOffset // Stay open
      }
      
      setTimeout(() => {
        this.isAnimating = false
      }, 500)
    }
  }
}
</script>
